import { Tag } from 'antd';
import { DataTableColumnHeader } from 'common/data-table-column-header';
import {
  booleanCell,
  dateTimeCell,
  linkCell,
} from 'utils/cell-formatter';

const roleColors: Record<string, string> = {
  superadmin: 'red',
  admin: 'blue',
  staff: 'green',
};

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/admin/staff-accounts' }),
  },
  {
    accessorKey: 'email',
    header: 'Email',
  },
  {
    accessorKey: 'name',
    header: 'Name',
  },
  {
    accessorKey: 'title',
    header: 'Title',
  },
  {
    accessorKey: 'role',
    header: 'Role',
    cell: ({ getValue }) => {
      const role = getValue();
      if (!role) return '-';
      return <Tag color={roleColors[role] || 'default'}>{role}</Tag>;
    },
  },
  {
    accessorKey: 'is_active',
    header: 'Active',
    meta: {
      className: 'text-center',
    },
    cell: booleanCell,
  },
  {
    accessorKey: 'has_password',
    header: 'Has Password',
    meta: {
      className: 'text-center',
    },
    cell: booleanCell,
  },
  {
    accessorKey: 'two_factor_enabled',
    header: '2FA',
    meta: {
      className: 'text-center',
    },
    cell: booleanCell,
  },
  {
    accessorKey: 'created_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created" />
    ),
    cell: dateTimeCell,
  },
  {
    accessorKey: 'updated_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Updated" />
    ),
    cell: dateTimeCell,
  },
];
